export const BROWSER_TYPES = {
  CHROME: "chrome",
  FIREFOX: "firefox",
  SAFARI: "safari",
  OPERA: "opera",
  EDGE: "edge",
  OTHERS: "others"
}

export default function() {
  const userAgent = navigator.userAgent

  if(userAgent.match(/chrome|chromium|crios/i))
    return BROWSER_TYPES.CHROME
  if(userAgent.match(/firefox|fxios/i))
    return BROWSER_TYPES.FIREFOX
  if(userAgent.match(/safari/i))
    return BROWSER_TYPES.SAFARI
  if(userAgent.match(/opr\//i))
    return BROWSER_TYPES.OPERA
  if(userAgent.match(/edg/i))
    return BROWSER_TYPES.EDGE
  return BROWSER_TYPES.OTHERS
}
